<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'USERS.BULK_UPDATE_SETTINGS.BULK_UPDATE_SETTINGS' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'USERS.TITLE' | translate"
        [previousPageUrl]="'/bc-admin'"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper [maxWidth]="1160">
    <div class="changes-container">
      <mat-card appearance="outlined" class="settings">
        <mat-tab-group [dynamicHeight]="true" mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab [label]="'USERS.BULK_UPDATE_SETTINGS.TAB_ACCESS' | translate">
            <app-bulk-tab-access-change></app-bulk-tab-access-change>
          </mat-tab>
          <mat-tab [label]="'USERS.BULK_UPDATE_SETTINGS.NOTIFICATIONS' | translate">
            <app-bulk-notifications-change></app-bulk-notifications-change>
            <div class="notification-scope-selector">
              <p>{{ 'USERS.BULK_UPDATE_SETTINGS.UPDATE_ALL_BUSINESSES' | translate }}</p>
              <mat-slide-toggle (change)="updateBulkNotificationScope($event)"></mat-slide-toggle>
              <p>{{ 'USERS.BULK_UPDATE_SETTINGS.UPDATE_USER_DEFAULTS' | translate }}</p>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card>
      <div class="changes-summary">
        <glxy-alert
          type="info"
          *ngIf="showDefaultNotificationPromotes && (newDefaultNotificationEnabled$ | async)"
          [showClose]="true"
          (close)="defaultNotificationPromoteClose()"
        >
          {{ 'USERS.BULK_UPDATE_SETTINGS.NEW_NOTIFICATION_DEFAULT_PROMOTE' | translate }}
          <button mat-stroked-button color="primary" routerLink="/bc-admin/users/notification-defaults">
            {{ 'USERS.BULK_UPDATE_SETTINGS.EDIT_NOTIFICATION_DEFAULTS' | translate }}
          </button>
        </glxy-alert>

        <h2>
          {{ 'USERS.BULK_UPDATE_SETTINGS.SELECTED_CHANGES' | translate }}
        </h2>
        <div *ngIf="noChangesSelected" class="no-changes-selected">
          {{ 'USERS.BULK_UPDATE_SETTINGS.ANY_CHANGES_WILL_APPEAR_HERE' | translate }}
        </div>
        <div class="changes" *ngIf="tabAccessChanges$ | async as tabAccessChanges">
          <mat-card
            appearance="outlined"
            class="mat-elevation-z0"
            *ngIf="tabAccessChanges[0].length > 0 || tabAccessChanges[1].length > 0"
          >
            <h3>Tab Access</h3>
            <ng-container *ngIf="tabAccessChanges[0].length > 0">
              <div class="change" *ngFor="let tab of tabAccessChanges[0]">
                <div class="change-name">- {{ tab.name }}</div>
                <va-badge color="green">
                  {{ 'USERS.BULK_UPDATE_SETTINGS.TURN_ON' | translate }}
                </va-badge>
              </div>
            </ng-container>
            <ng-container *ngIf="tabAccessChanges[1].length > 0">
              <div class="change" *ngFor="let tab of tabAccessChanges[1]">
                <div class="change-name">- {{ tab.name }}</div>
                <va-badge color="red">
                  {{ 'USERS.BULK_UPDATE_SETTINGS.TURN_OFF' | translate }}
                </va-badge>
              </div>
            </ng-container>
          </mat-card>
        </div>
        <div class="changes" *ngIf="notificationChanges$ | async as notifcationChanges">
          <mat-card appearance="outlined" class="mat-elevation-z0" *ngIf="notifChanges">
            <h3>
              {{ 'USERS.BULK_UPDATE_SETTINGS.NOTIFICATIONS' | translate }}
            </h3>
            <ng-container *ngFor="let notif of notifcationChanges">
              <div class="change" *ngIf="notif.valueFlag === LegacyStatus.STATUS_ENABLED">
                <div class="change-name">- {{ notif.title }}</div>
                <va-badge color="green">
                  {{ 'USERS.BULK_UPDATE_SETTINGS.ENABLE' | translate }}
                </va-badge>
              </div>
              <div class="change" *ngIf="notif.valueFlag === LegacyStatus.STATUS_DISABLED">
                <div class="change-name">- {{ notif.title }}</div>
                <va-badge color="red">
                  {{ 'USERS.BULK_UPDATE_SETTINGS.DISABLE' | translate }}
                </va-badge>
              </div>
              <div class="change" *ngIf="notif.valueFlag === LegacyStatus.STATUS_DEFAULT">
                <div class="change-name">- {{ notif.title }}</div>
                <va-badge color="yellow">
                  {{ 'USERS.BULK_UPDATE_SETTINGS.SET_DEFAULT' | translate }}
                </va-badge>
              </div>
            </ng-container>
          </mat-card>
        </div>
        <button mat-raised-button color="primary" [disabled]="noChangesSelected" (click)="applyChanges()">
          {{ applyChangesBtnText$ | async }}
        </button>
      </div>
    </div>
  </glxy-page-wrapper>
</glxy-page>
